export const MIN_NAME_FIELD_VALUE = 2;
export const MAX_NAME_FIELD_VALUE = 128;
export const MIN_PASSWORD_FIELD_VALUE = 8;
export const MAX_PASSWORD_FIELD_VALUE = 128;
